import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  Paper,
  CircularProgress,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { Link as RouterLink } from 'react-router-dom';
import { invokeApig } from '../lib/awsLib';
import CustomerForm from '../containers/customer/CustomerForm';
import NeokodeButton from '../components/NeokodeButton';

const useStyles = makeStyles((theme) => ({
  section: {
    margin: theme.spacing(3, 0),
    marginBottom: theme.spacing(10),
    width: 'inherit',
  },
  gridMaxWidth: {
      [theme.breakpoints.up('md')]: {
          maxWidth: theme.breakpoints.values.md,
      },
  },
  paper: {
      padding: theme.spacing(2),
  },
  
}));

function CustomerPage(props) {
  const classes = useStyles();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [message, setMessage] = useState('');
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    getCustomer();
  }, []);

  const getCustomer = async() => {
    if (id) {
        try {
            setIsLoading(true);
            const response = await invokeApig({
                path: `/account/${id}`
            });
            if (response.code === 200) {
              setCustomer(response.payload);
            } else {
              setMessage('Error al rescatar datos del cliente. Intenta nuevamente, si el error persiste contacta a Soporte.');
              setIsError(true);
            }
        } catch (error) {
          setMessage('Error al obtener los datos del cliente. Intanta nuevamente o comunícate con Soporte');
          setIsError(true)
        }
    }
    setIsLoading(false);
  }

  const goCustomerList = () => {
    props.history.push('/customers');
  }

  return (
    <Grid container spacing={2} className={classes.section} justifyContent="center">
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.gridMaxWidth}>
        <Paper className={classes.paper}>
          <Typography variant="h4" gutterBottom>
            {!!id ? 'Editar' : 'Crear'} cliente
          </Typography>
          {
            isLoading ?
            <CircularProgress />
            :
            (
              isError ?
              <>
                <Alert severity="error">
                    {message}
                </Alert>
                <NeokodeButton
                  type="button"
                  variant="contained"
                  className={classes.button}
                  component={RouterLink}
                  to="/customers"
                >
                  Volver al listado de clientes
                </NeokodeButton>
              </>
              :
              <CustomerForm {...props} customer={customer} onFinish={goCustomerList} />
            )
          }
        </Paper>
      </Grid>
    </Grid>
  );
}

export default CustomerPage;
